/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const updateDemandRequestSchema = z.object({
  description: z.string().nullish(),
  ownerId: z.string().nullish(),
  title: z.string().nullish(),
});
